import { useNavigate } from "react-router-dom";
import { Form, Input, Button } from "antd";
import { useState } from "react";
import "./LoginForm.css";
import authService from "../../../services/auth.service";
import { useAuth } from "../../../components/AuthContext";
import ChangePassword from "../../../components/ChangePassword";
import logo_dark from "../../../img/logo_white.png";

function LoginForm() {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [korisnickoIme, setKorisnickoIme] = useState("");
  const [staraLozinka, setStaraLozinka] = useState("");

  const handlelogin = async (values) => {
    try {
      const response = await authService.login(values);
      const role = response.role;
      const privremenaLozinka = response.privremenaLozinka;
      if (response.aktivan === 0 || response.aktivan === false) {
        alert("Vaš nalog je deaktiviran. Prijava nije moguća.");
        return;
      }
      if (response && response.role) {
        const user = await authService.checkStatus();
        if (user?.username) {
          login(user);
          window.isRedirecting = false;
        }
      }
      setKorisnickoIme(values.username);
      setStaraLozinka(values.password);

      if (privremenaLozinka && role === "ROLE_ZAPOSLENI") {
        setShowChangePasswordModal(true);
      } else {
        if (role === "ROLE_ZAPOSLENI") {
          navigate("/zaposleni/home");
        } else if (role === "ROLE_ADMIN") {
          navigate("/admin/home");
        } else {
          navigate("/home");
        }
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 500) {
          alert("Vaš nalog nije aktivan. Prijava nije moguća.");
        } else if (
          error.response.data &&
          typeof error.response.data === "string"
        ) {
          alert("Greška pri loginu: " + error.response.data);
        } else if (error.response.data && error.response.data.message) {
          alert("Greška pri loginu: " + error.response.data.message);
        } else {
          alert("Greška pri loginu: Nepoznata greška sa servera.");
        }
      } else {
        alert("Greška pri loginu: " + error.message);
      }
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-left">
          <Form layout="vertical" onFinish={handlelogin} className="login-form">
            <h1 className="login-title">Prijava</h1>
            <Form.Item
              name="username"
              label="Korisničko ime"
              rules={[{ required: true, message: "Unesite korisničko ime" }]}
            >
              <Input placeholder="Korisničko ime" />
            </Form.Item>
            <Form.Item
              name="password"
              label="Lozinka"
              rules={[{ required: true, message: "Unesite lozinku" }]}
            >
              <Input.Password placeholder="Lozinka" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" className="login-button">
                Prijavi se
              </Button>
            </Form.Item>
          </Form>
        </div>
        <div className="login-right">
          <img src={logo_dark} alt="Login" />
        </div>
      </div>

      {showChangePasswordModal && (
        <ChangePassword
          visible={showChangePasswordModal}
          onClose={() => setShowChangePasswordModal(false)}
          korisnickoIme={korisnickoIme}
          staraLozinka={staraLozinka}
        />
      )}
    </div>
  );
}

export default LoginForm;
